import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { containerStyles } from "@insite/content-library/Widgets/OnePageCheckout/OnePageCheckoutPageContainer";
import { css } from "styled-components";

containerStyles.container = mergeToNew(containerStyles.container, {
    css: css`
        padding-bottom: 24px;
    `,
});

containerStyles.leftGridItem = mergeToNew(containerStyles.leftGridItem, {
    width: [12, 12, 6, 9, 9],
    css: css`
        & > div > div:not(:last-child) {
            border-bottom: 0;
            box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075);
            margin-bottom: 16px;
            padding-bottom: 0;
        }
    `,
});

containerStyles.rightGridItem = mergeToNew(containerStyles.rightGridItem, {
    width: [12, 12, 5, 3, 3],
});
